import {
  NumberInput as MantineNumberInput,
  NumberInputProps,
} from '@mantine/core';
import {AdapterProps, FieldAdapter} from '../field-factory';
import {FC} from 'react';
import {currencyValueConverter} from '../value-converters';

export type $CurrencyInputAdapterProps = AdapterProps<
  Omit<
    NumberInputProps,
    'parser' | 'formatter' | 'hideControls' | 'min' | 'type'
  >
>;

export const $CurrencyInputAdapter: FC<
  FieldAdapter<$CurrencyInputAdapterProps>
> = (props) => {
  const {
    inputProps: {onChange, decimalScale = 2, ...inputProps},
    control,
  } = props;

  const {
    field: {onChange: fieldOnChange, value, ...fieldProps},
    fieldState: {invalid}
  } = control;

  const _onChange: $CurrencyInputAdapterProps['onChange'] = (e) => {
    const val = currencyValueConverter.parseInput(e);
    fieldOnChange(val);
    onChange?.(val);
  };

  return (
    <MantineNumberInput
      error={invalid}
      hideControls
      min={0}
      prefix={'$'}
      decimalScale={decimalScale}
      fixedDecimalScale
      onChange={_onChange}
      value={currencyValueConverter.format(value)}
      {...fieldProps}
      {...inputProps}
    />
  );
};